import { Tabs, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import TabPane from "antd/es/tabs/TabPane";
import UserMain from "./user-main";
import UserProducts from "./user-products";
import { useState } from "react";
import { isMobile } from "../../../extensions/design";

const tabsConfig = [
  { key: "1", label: "Общее" },
  { key: "2", label: "Услуги" },
];

const User = ({ id, onClose, companyId, userName }) => {
  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (key) => {
    if (key === "2" && !id) return;
    setActiveTab(key);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "1": return <UserMain id={id} onClose={onClose} companyId={companyId} />;
      case "2": return <UserProducts id={id} onClose={onClose} />;
      default: return null;
    }
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
        <div className={isMobile ? "sport-modal-content mobile-content" : "sport-modal-content"} style={isMobile ? {} : {width: 800}}>
          <div className={isMobile ? "sport-modal-title-client" : "client-modal-title"}>
            <span style={{fontSize: "14px"}}>Пользователь</span>
            {isMobile && (
              <Select className="mobile-tabs-select" value={activeTab} onChange={handleTabChange} style={{ width: "58%", marginRight: "0px" }}>
                {tabsConfig.map(({ key, label }) => (
                  <Select.Option key={key} value={key} disabled={key === "2" && !id}>
                    {label}
                  </Select.Option>
                ))}
              </Select>
            )}
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9, marginLeft: "auto", cursor: "pointer" }}/>
            {isMobile ? <div className="client-name">{userName}</div> : <></>}
          </div>

          {isMobile ? (
            <div className="product-mobile-content">{renderContent()}</div>
          ) : (
            <div className="custom-tabs-container">
              <Tabs type="card" className="custom-tabs" activeKey={activeTab} onChange={handleTabChange}>
                <TabPane tab="Общее" key="1">
                  <UserMain id={id} onClose={onClose} companyId={companyId} />
                </TabPane>
                <TabPane tab="Услуги" key="2" disabled={!id}>
                  <UserProducts id={id} onClose={onClose} />
                </TabPane>
              </Tabs>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default User;

